var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHappyEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 72.111c15.525 0 28.111-12.586 28.111-28.111s-12.586-28.111-28.11-28.111c-15.526 0-28.112 12.586-28.112 28.111S28.475 72.111 44 72.111z",
    fill: "#FFD6C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72.111c15.525 0 28.111-12.586 28.111-28.111S59.525 15.889 44 15.889 15.889 28.475 15.889 44 28.475 72.111 44 72.111zM55.996 55.277a18.858 18.858 0 01-23.992 0",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.737 40.827a5.776 5.776 0 00-10.558 0M59.82 40.827a5.777 5.777 0 00-10.557 0",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default SvgHappyEmoji;